import type { SVGProps } from "react";
export interface GridDotsBottomIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GridDotsBottomIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GridDotsBottomIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 16.497v-.006a1.126 1.126 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.126 1.126 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.126 1.126 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0M3 10.87c.235 0 .453.072.633.195.097.066.18.15.252.242q.026.03.05.061a1.12 1.12 0 0 1 .006 1.245 1.122 1.122 0 0 1-1.874.017 1.117 1.117 0 0 1 .196-1.478c.198-.173.454-.282.737-.282m8.997 0a1.124 1.124 0 0 1 .933 1.76 1.124 1.124 0 0 1-1.866 0 1.125 1.125 0 0 1 .933-1.76m8.997 0c.284 0 .54.109.737.282a1.117 1.117 0 0 1 .196 1.478 1.125 1.125 0 0 1-1.875-.016 1.12 1.12 0 0 1 .006-1.246q.024-.031.05-.061c.072-.092.155-.176.252-.242.18-.123.4-.194.634-.195m-13.492.002.114.006a1.126 1.126 0 0 1 0 2.238l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0a1.126 1.126 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zM1.875 7.5v-.005a1.125 1.125 0 0 1 2.25 0V7.5a1.125 1.125 0 0 1-2.25 0m8.997 0v-.005a1.125 1.125 0 0 1 2.25 0V7.5a1.125 1.125 0 0 1-2.25 0m8.997 0v-.005a1.125 1.125 0 0 1 2.25 0V7.5a1.125 1.125 0 0 1-2.25 0M3 1.871c.234 0 .452.073.632.195a1.125 1.125 0 0 1 .307 1.553 1 1 0 0 1-.094.117 1.12 1.12 0 0 1-1.778-.105 1.12 1.12 0 0 1 .138-1.43A1.12 1.12 0 0 1 3 1.871m8.997 0c.235 0 .452.073.632.195a1.125 1.125 0 0 1-.005 1.868 1.12 1.12 0 0 1-1.255 0 1.124 1.124 0 0 1-.003-1.868c.18-.122.397-.195.631-.195m8.997 0c.311 0 .592.126.796.33a1.12 1.12 0 0 1 .137 1.43 1.125 1.125 0 0 1-1.561.303 1.1 1.1 0 0 1-.218-.198q-.05-.055-.094-.117a1.12 1.12 0 0 1 .309-1.553 1.1 1.1 0 0 1 .631-.195m-13.492.003a1.125 1.125 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0a1.125 1.125 0 0 1 0 2.25h-.006a1.126 1.126 0 0 1 0-2.25zM21 19.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
